module.exports = __webpack_public_path__ + "img/sld_mfm_inv_18_t1_b1_dark.938c69c6.svg";